(function ($) {
    $(function () {
        var $header = $('.header'),
            $megaMenu = $('.mega-menu'),
            $mainNav = $('.main-nav:not(.main-nav--mobile)'),
            $megaContent = $megaMenu.find('.content__section');

        // open (or close) a sub-menu
        $('.main-nav__link', $mainNav).on('click', function clickLink(e) {
            e.preventDefault();

            var $this = $(this);
            var $parent = $this.closest('.main-nav__item');
            var clickedActiveLink = $parent.hasClass('main-nav__item--active');

            // close all links
            $('.main-nav__item', $mainNav).removeClass('main-nav__item--active');

            if ($mainNav.data('closing')) {
                clearTimeout($mainNav.data('closing'));
                $mainNav.data('closing', '');
            }

            if (clickedActiveLink) {
                closeMenu();
            } else {
                // menu is not yet active
                $parent.addClass('main-nav__item--active');
                $megaMenu.addClass('mega-menu--visible');
                $header.addClass('header--expanded');
            }

            // set new content section active
            $megaContent.removeClass('content__section--shown');
            $megaContent.filter($this.attr('href')).addClass('content__section--shown');

            // set mega-menu theme
            $megaMenu.attr('data-theme', $parent.data('theme'));
        });

        // close the menu if clicked outside
        $(document).on('click', function clickOutside(e) {
            let $clickedElm = e.target;
            let $parent = $clickedElm.closest('.main-nav, .mega-menu');

            if (!$parent) {
                closeMenu();
            }
        });

        function closeMenu() {
            // close all links
            $('.main-nav__item', $mainNav).removeClass('main-nav__item--active');

            // clicked on active menu item - close the menu
            $megaMenu.removeClass('mega-menu--visible');

            // wait for transition on #content .mega-menu__main .content__section
            let timeout = setTimeout(function () {
                $header.removeClass('header--expanded');
            }, 1000);

            $mainNav.data('closing', timeout);

        }
    });
})(jQuery);